<template>
  <form-group>
    <span class="upload_photo">
      <label class="file">
        <span class="file-custom">
          <input
            type="file"
            id="file"
            ref="myFiles"
            accept="image/*"
            @change="sendFileToParent"
            multiple
          />
        </span>
        <img src="../../assets/images/camera.svg" class="camera_icon" />
        <span class="addphoto_text">{{$t('AddPhoto')}}</span>
      </label>
      <div class="loader" v-if="loading">
        <p>{{$t('UploadingImage')}}</p>
        <img src="../../assets/images/gif-loader.gif" />
      </div>
    </span>
  </form-group>
</template>
<script>
import axios from "axios";
import {getBase64Url} from "../../utils/helper";
import { FILE_UPLOAD_URL } from "../../utils/constant";
export default {
  props: {
    value: {
      type: String,
      default: null
    }
  },
  components: {},
  data() {
    return {
      loading: false,
      uploadBusinessPhoto: ''
    };
  },
  methods: {
    async sendFileToParent(file) {
      const image = file.target.files[0];
      if (!image.type.includes("image/")) {
        alert("Please select an image file");
        return;
      }
       getBase64Url(image).then(data => {
          this.uploadBusinessPhoto = data;
          this.$emit("photoEmit", this.uploadBusinessPhoto);
        });
    }
  }
};
</script>
<style></style>
